import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PromotionService, BannerContract, AlertService, CorpInfo } from '../../../services/index';
import { Util, REST_API_REQUEST_CALL_URL } from '../../../utils';
declare var $:any;

declare var moment:any;

@Component({
  selector: 'contract-detail',
  templateUrl: 'contract-detail.html'
})
export class ContractDetailComponent {
  
  _contract: BannerContract
  @Input() set contract(contract: BannerContract){
    if(!contract) return;

    if(contract.bannerContractId != null && contract.endDt != null) this.isDisabledEndDt = true;
    if(contract.sellAmount) contract.sellAmount = this.addComma(contract.sellAmount);
    if(contract.contractAmount) contract.contractAmount = this.addComma(contract.contractAmount);

    this._contract = contract;
  }
  get contract():BannerContract{
    return this._contract;
  }

  @Input() isEditing: boolean;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  
  numberWithCommas:Function = Util.numberWithCommas;

  parseToDate:Function = Util.parseDate;
  isDisabledEndDt = false;

  constructor(
    private promotionService: PromotionService,
    private alertService: AlertService,
  ) {}

  close() {
    this.onClose.emit(null);
  }

  selectCorp(event) {
    if(event != null) {
      this.contract.corporation = event;
    }
  }

  setStartDtm(event) {
    let dt = moment(event).format('YYYYMMDD');
    this.contract.startDt = dt;
  }
  
  setEndDtm(event) {
    if(!event || event == 'Invalid Date'){
      this.contract.endDt = null;
    }else{
      let dt = moment(event).format('YYYYMMDD');
      this.contract.endDt = dt;
    }
    
  }

  countrySelected(event) {
    if(event!=null) {
      this.contract.countryName = event.countryName;
      this.contract.countryCode = event.countryCode;
      this.contract.sellAmount = this.addComma(event.price);
    }
  }

  saveContract() {
    if(this.contract.sellAmount) this.contract.sellAmount = this.removeCommas(this.contract.sellAmount);
    if(this.contract.contractAmount) this.contract.contractAmount = this.removeCommas(this.contract.contractAmount);
    
    if (localStorage.getItem('currentUser')) {
      let profile = JSON.parse(localStorage.getItem('currentUser')); 
      let email = profile.displayName;
      // if(email.indexOf('heechan022@naver.com') < 0 && email.indexOf('hyungeun@tradlinx.com') < 0 && email.indexOf('info@tradlinx.com') < 0
      //   && email.indexOf('jongho@tradlinx.com') < 0 && email.indexOf('demian@tradlinx.com') < 0 && email.indexOf('hyojinan@tradlinx.com') < 0 ){
      if(REST_API_REQUEST_CALL_URL.BASE_URL.indexOf("http://inner.tradlinx.com:8443") > -1){
        if(email.indexOf('heechan022@naver.com') < 0 && email.indexOf('hyungeun@tradlinx.com') < 0 && email.indexOf('info@tradlinx.com') < 0 && email.indexOf('demian@tradlinx.com') < 0) {
          $.sweetModal({
            content: "특정 인원만 저장이 가능합니다. 담당자에게 문의해주세요.",
            icon: $.sweetModal.ICON_WARNING
          });
          return ;
        }
      }
    }

    if(this.isEditing) {
      this.promotionService.patchContract(this.contract).subscribe(
        resp => {
          if(resp.result) {
            this.alertService.success('계약이 수정되었습니다.');
            this.onClose.emit('save');
          }
        }
      )
    } else {
      this.promotionService.postContract(this.contract).subscribe(
        resp => {
          if(resp.result) {
            this.alertService.success('계약이 추가되었습니다.');
            this.onClose.emit('add');
          }
        }
      ); 
    }
  }

  addComma(event){
    if(event != null && event.target != null) {
      event.target.value = Util.numberWithCommas(event.target.value);
    }else{
      return Util.numberWithCommas(event);
    }
  }

  removeCommas (event){
    if(event != null && event.target != null) {
      event.target.value = event.target.value.replace(/,/gi, ""); 
    }
    else if(event != null && event.target == null){
      return event.replace(/,/gi, ""); 
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/promotion/contract/contract-detail.ts